import { render, staticRenderFns } from "./TextEditorOld.vue?vue&type=template&id=2c7ee124&scoped=true&lang=pug&"
import script from "./TextEditorOld.vue?vue&type=script&lang=js&"
export * from "./TextEditorOld.vue?vue&type=script&lang=js&"
import style0 from "./TextEditorOld.vue?vue&type=style&index=0&id=2c7ee124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7ee124",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
